import React, { FC } from 'react';
import { CustomStepper } from './CustomStepper';

interface Stepper {
  title: string;
  stepNames: string[];
  stepElements: JSX.Element[];
  activeStep: number;
}

export const Stepper: FC<Stepper> = ({ title, stepNames, stepElements, activeStep }) => {
  return (
    <div className="stepper">
      <p className="stepper__title">{title}</p>
      <CustomStepper activeStep={activeStep} className="primary" steps={stepNames} />
      {stepElements.map((el, index) => {
        return activeStep === index && el;
      })}
    </div>
  );
};
